const API_URL = process.env.REACT_APP_API_URL
import BaseApi from "./baseApi"

class EventsApi extends BaseApi {
  constructor() {
    super()
    this.baseUrl = "/dashboard"
    this.baseEventUrl = "/events"
    this.baseAwardUrl = "/awards"
  }

  createEvent(data, token) {

    const endPoint = `${API_URL}${this.baseUrl}/add-event`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    }

    return this.fetchData(axiosRq)
    /*   .then(response => {
        return response
      })
      .catch(error => {
        console.error("Error in createEvent:", error)
        throw error
      }) */
  }

  updateEvent(data, token) {
    const endPoint = `${API_URL}${this.baseUrl}/edit-event`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    }
    return this.fetchData(axiosRq)
  }

  getEventDetails(eventId, token) {
    const endPoint = `${API_URL}${this.baseUrl}/event/${eventId}`
    const axiosRq = {
      url: endPoint,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  fetchEvents(token, data) {
    const endPoint = `${API_URL}${this.baseUrl}/get-events-list`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }
  fetchEvents(token, data) {
    const endPoint = `${API_URL}${this.baseUrl}/get-events-list`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  fetchEventsTickets(data, token) {

    const endPoint = `${API_URL}${this.baseEventUrl}/get-all-tickets-users`

    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }

    return this.fetchData(axiosRq)
  }
  fetchEventsTicketsExcel(data, token) {
    const endPoint = `${API_URL}${this.baseEventUrl}/get-all-tickets-users-excel`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  createEventBookingOrder(data, token) {
    const endPoint = `${API_URL}${this.baseEventUrl}/create-booking-order`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }

  verifyEventPayment(data, token) {
    const endPoint = `${API_URL}${this.baseEventUrl}/verify-payment`
    const axiosRq = {
      url: endPoint,
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    return this.fetchData(axiosRq)
  }
}

const eventsApi = new EventsApi()

export default eventsApi
